import {
    ApiClientAxios,
    apiFactoryConfig,
    SendAuthenticationSMSRequest,
    SendAuthenticationSMSResponse,
} from "@repo/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useSmsVerificationCodeMutation = (
    options?: Partial<UseMutationOptions<SendAuthenticationSMSResponse, unknown, SendAuthenticationSMSRequest>>,
) => {
    const api = ApiClientAxios.AuthenticateApiFactory(...apiFactoryConfig);
    return useMutation<SendAuthenticationSMSResponse, unknown, SendAuthenticationSMSRequest>({
        mutationFn: async (data: SendAuthenticationSMSRequest) => {
            const response = await api.sendAuthenticationSMSPost({
                phoneNumber: data.phoneNumber,
            });
            return response.data;
        },
        ...options,
    });
};
